import { create } from "zustand";

const PollingProfileStore = create((set) => ({
  profileId: "testId",
  setProfileId: (profile) => {
    set(() => ({
      profileId: profile,
    }));
  },
}));

export default PollingProfileStore;
